import lazy from '@fatso83/retry-dynamic-import/react-lazy';
import { Suspense } from 'react';
import TableDialog, { TableDialogVariant } from 'components/TableDialog';
import { MutationOutcome } from 'utils/offlineQueryMutation';
import { useGlobalContent } from './useGlobalContent';
import { SnackbarVariant, useSnackbar } from './useSnackBar';

// This hook is mounted for the whole session by the mutation queue processor, but the
// graphic is a ~60KB inline SVG only ever rendered inside the dialog below, so it is
// kept out of the entry chunk.
const ShipmentGraphic = lazy(() => import('components/ShipmentGraphic'));

const SUCCESS_DURATION_MS = 3000;
const FAILURE_DURATION_MS = 6000;

const useOfflineMutationResult = () => {
  const { showContent, hideContent } = useGlobalContent();
  const { showSnackbar } = useSnackbar();

  //We only handle EditShipments Table Dialogs for now, this can be customized in the future
  const showMutationOutcome = ({ isSuccess, message, color, dialogs }: MutationOutcome) => {
    if (dialogs.length) {
      showContent(
        <TableDialog
          data={dialogs}
          variant={TableDialogVariant.Detailed}
          graphic={
            <Suspense fallback={null}>
              <ShipmentGraphic />
            </Suspense>
          }
          onClose={hideContent}
        />,
      );
    }
    // A server toast brings its own colour; otherwise failures take the app's error styling.
    const isAlert = isSuccess || !!color;
    showSnackbar(
      {
        message,
        color: color ?? (isSuccess ? 'success' : undefined),
        autoHideDuration: isSuccess ? SUCCESS_DURATION_MS : FAILURE_DURATION_MS,
      },
      isAlert ? SnackbarVariant.ALERT : SnackbarVariant.ERROR,
    );
  };

  return { showMutationOutcome };
};

export default useOfflineMutationResult;
